import { Component, Input, ChangeDetectionStrategy, OnChanges, OnInit } from '@angular/core';

import { BookingService } from 'libraries/service/booking/booking.service';
import { Yii } from "libraries/interfaces/Yii";
import { IAirTotal } from 'libraries/service/resources/model/search/air/IAirTotal';
import { IGetBookingsCommonResponse } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { BookingType } from "libraries/service/resources/booking/interfaces/get-bookings.enum";
import { EAirBookingPermissions } from "libraries/component/booking-information/e-air-booking-permissions.enum";
import { IHotelBooking } from "../../../../../../libraries/service/resources/model/search/hotel/IHotelBooking";
import { EStayPermissions } from "libraries/enums/e-stay-permissions";
import {
    PermissionResourceService
} from "../../../../../../libraries/service/resources/permission/permissionResource.service";

class Wording {
    public readonly pax: string = Yii.t("wui-sasha-js", "voyageurs");
    public readonly onePax: string = Yii.t("wui-sasha-js", "1 voyageur");
    public readonly cost: string = Yii.t("wui-sasha-js", "Total des tarifications :");
    public readonly retail: string = Yii.t("wui-sasha-js", "Total prix de vente :");
    public readonly price: string = Yii.t("wui-sasha-js", "Prix Total:");
    public readonly pending: string = Yii.t("wui-shared-js", "Valeur restante des billets :");
    public readonly used: string = Yii.t("wui-shared-js", "Valeur consommée des billets :");
    public readonly issued: string = Yii.t("wui-shared-js", "Total des billets émis :");
}

@Component({
    selector: 'booking-header',
    template: `
        <div class="booking-header"
             [ngClass]="{'no-type-booking': !booking.type?.length}">
            <div class="identifier">
                <ng-container matColumnDef="col1">
                </ng-container>
                <div class="identifier-content">
                    <booking-status [status]="booking.xStatus"></booking-status>
                    <!-- FIXME @trebufet : path="sasha.booking.detail.air.view"
                        - 'air' should'nt be static, could be hotel instead or another booking type
                        - not done yet because not sure the "sasha.booking.detail.stay.view" exists-->
                    <permission class="sep-left-bkhder" path="sasha.booking.detail.air.view">
                        <a class="has-permission code e2e-confirm-first-booking"
                           [routerLink]="link">
                            {{ booking.code }}
                        </a>
                        <span class="has-no-permission code">
                                            {{ booking.code }}
                                        </span>
                    </permission>
                        <span class="host"
                              *permissionIf="permissions.SHARED_HOST_SHOW">
                                            {{ booking.host | hostAlias | async }}
                                        </span>
                        <span *ngIf="booking.carrier?.name">{{booking.carrier.name}}</span>
                </div>
                <ng-content select=".col-1-bottom"></ng-content>
            </div>
            <div class="pax e2e-chooseFirst-booking">
                <div class="pax-content">
                        <span *ngIf="booking.customer" class="mainTraveller">
                        {{ booking.customer.firstName }} {{ booking.customer.lastName }}
                        </span>
                    &nbsp;
                    <span [ngPlural]="travellerCount" *ngIf="travellerCount" class="traveller-count test">
                    <ng-template ngPluralCase="=1">{{labels.onePax}}</ng-template>
                    <ng-template ngPluralCase="other">{{travellerCount}} {{labels.pax}}</ng-template>
                    </span>
                </div>
                <ng-content select=".col-2-bottom"></ng-content>
            </div>
            <div class="price" *ngIf="booking.type && booking.type[0] === bookingType.air">
                <ng-container *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_PRICE_SHOW">
                    <div *ngFor="let price of prices" class="price-container">
                        <ng-container *ngIf="price?.xType">
                            <div class="label-container">{{labels[price.xType]}}</div>
                            <div class="price-element"><span
                                    [innerHtml]="price?.amount | priceRealAmount:price.currency"></span></div>
                        </ng-container>
                    </div>
                </ng-container>
                <ng-container *ngIf="historyPrices">
                    <ng-container *permissionIf="airBookingPermissions.SHARED_AIR_BOOKING_PRICE_HISTORY_SHOW">
                        <div class="price-container">
                            <div class="label-container">{{labels.issued}}</div>
                            <div class="price-element"><span
                                    [innerHtml]="historyPrices.history.issuedValue | price:historyPrices.history.currency"></span>
                            </div>
                        </div>
                        <div class="price-container">
                            <div class="label-container">{{labels.used}}</div>
                            <div class="price-element"><span
                                    [innerHtml]="historyPrices.history.usedValue | price:historyPrices.history.currency"></span>
                            </div>
                        </div>
                        <div class="price-container">
                            <div class="label-container">{{labels.pending}}</div>
                            <div class="price-element"><span
                                    [innerHtml]="historyPrices.history.pendingValue | price:historyPrices.history.currency"></span>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                <span *ngIf="!prices?.length">-</span>
            </div>
            <div class="price" *ngIf="booking.type && booking.type[0] === bookingType.stay">
                <div *ngFor="let price of prices">
                    <span *ngIf="price.xType && price.xType === 'cost' && hasRetailPrice">{{labels.cost}}</span>
                    <span *ngIf="price.xType && price.xType === 'retail' && hasCostPrice">{{labels.retail}}</span>
                    <span [innerHtml]="price?.amount | priceRealAmount:price?.currency"></span>
                </div>
                <span *ngIf="!prices?.length">-</span>
            </div>
            <div class="price" *ngIf="isVehicleRental">
                <div *ngFor="let price of prices">
                    <span [innerHtml]="price?.amount | priceRealAmount:price?.currency"></span>
                </div>
                <span *ngIf="!prices?.length">-</span>
            </div>
            <div class="price" *ngIf="!booking.type"></div>
            <div class="price"
                 *ngIf="booking.type?.length && !isVehicleRental && booking.type[0] !== bookingType.air && booking.type[0] !== bookingType.stay">
                &nbsp;
            </div>
            <div>
            </div>
        </div>

    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ["./booking-header.component.scss"],
    styles: [`
        table {
            width: 100%;
            border-collapse: collapse;
        }

        .twelve-grid {
            border: 0;
            padding: 0;
        }

        tr td {
            border: 1px solid black;
            padding: 0.75rem;
        }
    `]
})
export class BookingHeaderComponent implements OnChanges, OnInit {

    /**
     * in case we open the booking from a processing page, modify the url and breadcrumb
     */
    @Input()
    public processingId: number;

    @Input()
    public booking: IGetBookingsCommonResponse;

    @Input()
    public isVehicleRental: boolean = false;

    public labels: Wording = new Wording();

    public link: string[];
    public travellerCount: number = 0;
    public prices: IAirTotal[];
    public historyPrices: IAirTotal;
    public bookingType: typeof BookingType = BookingType;

    public showCostPrice: boolean = false;
    public showRetailPrice: boolean = false;
    public hasCostPrice: boolean = false;
    public hasRetailPrice: boolean = false;

    public airBookingPermissions: typeof EAirBookingPermissions = EAirBookingPermissions;

    constructor(
        private readonly permissionResource: PermissionResourceService) {
    }

    public ngOnInit(): void {
        this.permissionResource.getPermissionsStartingWith(['shared', 'stay', 'price']).subscribe((permissions: Set<string>): void => {
            this.showCostPrice = permissions.has('shared.stay.price.cost.show');
            this.showRetailPrice = permissions.has('shared.stay.price.retail.show');
            this.getFilteredPrices();
        });
    }

    public ngOnChanges(): void {
        this.link = this.getBookingDetailLink();
        this.travellerCount = this.booking && this.booking.traveller && this.booking.traveller.length;

        this.getFilteredPrices();

        this.historyPrices = (this.booking?.total || []).find((total: IAirTotal): boolean => Boolean(total.history));
    }

    public permissions: typeof EStayPermissions = EStayPermissions;

    /**
     * @method getBookingDetailLink
     * @description returns the routerLing parameter from the booking object properties
     */
    private getBookingDetailLink(): string[] {
        const commonBookingsRoute: string[] = ['/sasha', 'booking'];
        const commonProcessingRoute: string[] = [
            '/sasha',
            'processing',
            this.processingId ? this.processingId.toString() : '',
            'booking',
        ];

        return [
            ...(this.processingId ? commonProcessingRoute : commonBookingsRoute),
            this.booking.syscode
        ];
    }

    private getFilteredPrices(): void {
        // 2019-08-30
        // This is to avoid bugging when encountering a buggy format from before the correction of the XSL.
        this.prices = this.booking
            && this.booking.total
            && this.booking.total.filter((price: IAirTotal): boolean => {
                return price.currency && price.amount !== undefined &&
                    (!price.xType ||
                        (price.xType && (
                                (price.xType === 'retail' && this.showRetailPrice) ||
                                (price.xType === 'cost' && this.showCostPrice) ||
                                (price.xType !== 'retail' && price.xType !== 'cost')
                            )
                        )
                    );
            });

        this.hasCostPrice = Boolean((this.prices || []).find((price: IAirTotal): boolean => price.xType === 'cost'));
        this.hasRetailPrice = Boolean((this.prices || []).find((price: IAirTotal): boolean => price.xType === 'retail'));
    }
}
